import { atom, WritableAtom } from '@podium/store';
import { AdStatus } from '@schibsted-nmp/advertising-shared';

import { AtomChannels, AtomTopics } from './index';

export type AdContainerStyle = {
  adType: string;
  status: AdStatus;
};

export type AdContainerStyleMap = {
  [key: string]: AdContainerStyle;
};

// Create the GlobalAtom for ppid data
export const $adContainerStyleMap: WritableAtom<AdContainerStyleMap> =
  atom<AdContainerStyleMap>(AtomChannels.Podlet, AtomTopics.AdContainerMap, {});

export const addToAdContainerStyleMap = (
  containerId: string,
  adContainerData: AdContainerStyle
) => {
  const currentAdContainerStatusMap = $adContainerStyleMap.get();
  $adContainerStyleMap.set({
    ...currentAdContainerStatusMap,
    [containerId]: adContainerData
  });
};

export const getAdContainerStatusMap = () => $adContainerStyleMap.get();
